import styled from 'styled-components/macro';

export default styled.div`
  cursor: text;

  .public-DraftEditor-content {
    a {
      color: inherit;
    }
  }

  .draftJsToolbar__toolbar {
    left: 50%;
    transform: translate(-50%) scale(0);
    position: absolute;
    display: flex;
    background-color: #3d3234;
    border-radius: 4px;
    box-shadow: 0 4px 16px 0 rgba(40, 35, 36, 0.6);
    z-index: 2;
    box-sizing: border-box;
  }

  .draftJsToolbar__toolbar:after, .draftJsToolbar__toolbar:before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .draftJsToolbar__toolbar:after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: #3d3234;
    border-width: 4px;
    margin-left: -4px;
    box-shadow: 0 4px 16px 0 rgba(40,35,36,0.6);
  }
  .draftJsToolbar__toolbar:before {
    border-color: rgba(221, 221, 221, 0);
    border-top-color: #3d3234;
    border-width: 6px;
    margin-left: -6px;
  }

  .draftJsToolbar__buttonWrapper {
    display: block;
  }

  .draftJsToolbar__button {
    background-color: #3d3234;
    color: #e1e1e1;
    font-size: 18px;
    border: 0;
    padding: 0;
    height: 34px;
    width: 36px;
    outline: none;
  }

  .draftJsToolbar__button {
    opacity: 0.4;
    color: #fff;
    transition: opacity 0.25s ease-out;
  }

  .draftJsToolbar__button:hover,
  .draftJsToolbar__button:focus,
  .draftJsToolbar__active {
    opacity: 1;
  }
`;
